export const EDITOR_MANAGING_GR_INDICATORS_OPTIONS = [
  "number",
  "universalName",
  "quarter1",
  "quarter2",
  "quarter1_2",
  "quarter3",
  "quarter2_3",
  "quarter4",
  "quarter3_4",
  "yearValue",
  "yearPercent",
  "updatedAt",
];

export const EDITOR_MANAGING_GR_INDICATORS_PERIOD_OPTIONS = [
  "quarter1",
  "quarter2",
  "quarter1_2",
  "quarter3",
  "quarter2_3",
  "quarter4",
  "quarter3_4",
  "yearValue",
  "yearPercent",
];
